import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DtcRetrievalService, t_Dtc } from 'src/app/services/apiHandler/dtc-retrieval/dtc-retrieval.service';
import { interval } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from 'src/app/services/helper/global-helper';

interface InfoData {
  message?: string;
  spn?: number;
  fmi?: string;
  oc?: number;
  description?: string;
  effects?: string;
  suggestion?: string;
}

interface TableData {
  label: string;
  info: string | undefined;
}

@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss']
})

export class InfoDialogComponent {
  
  rowData: t_Dtc;
  dataSource: TableData[] = [];
  displayColumns: string[] = ["Label", "Info"];
  loaded: boolean = false;
  public initialized: boolean = false;
  detailMapping: any;
  noECU: boolean = false;
  line: string = '';
  

  constructor(@Inject(MAT_DIALOG_DATA) data: t_Dtc, private translate: TranslateService, private dtcRetrievalService: DtcRetrievalService, private global: GlobalService){
    this.global.machineInfos.subscribe({
      next: newValue => {this.line = newValue.line;}
    });
    if(data.ecuId != undefined) {
      this.dtcRetrievalService.getMappingFiles('dtc', data.ecuId!, this.line, 'en').subscribe((resp) => {
        this.detailMapping = JSON.parse(JSON.stringify(resp.body));
        this.loaded = true;
      });
    } else {
        // unkown ECU
        this.noECU = true;
    }
    this.rowData = data;
    // timer to intercept delay
    let timer = interval(1000).subscribe(() => {
      if(this.loaded){
        this.initData();  
        timer.unsubscribe();
      }
    });
  }

  private initData(){
    let data = this.detailMapping.data;
    let fmi = Number(this.rowData.fmi?.substring(0,this.rowData.fmi?.indexOf(' ')));
    let path = "J1939.SRC." + this.rowData.ecuId + ".SPN." + this.rowData.spn + ".FMI." + fmi;
    if(data[path] != undefined) {
      if(data != undefined){
        var description = data[path].descriptionService;
        var suggestion = data[path].suggestionService;
        var effects = data[path].effects;
      }
    } else {
      description = this.translate.instant("MESSAGES.UNAVAILABLE");
      suggestion = this.translate.instant("MESSAGES.UNAVAILABLE");
      effects = this.translate.instant("MESSAGES.UNAVAILABLE");
    }
    // fill table
    this.dataSource = [
      {label: this.translate.instant("DTC.TABLE.MESSAGE") + ":", info: this.rowData.message},
      {label: "SPN:", info: this.rowData.spn?.toString()},
      {label: "FMI:", info: this.rowData.fmi},
      //{label: "OC:", info: this.rowData.occurence?.toString()},
      {label: "", info: ""}, //Leerzeile für Anzeige
      {label: "", info: ""}, //Leerzeile für Anzeige
      {label: this.translate.instant("DTC.TABLE.DESCRIPTION") + ":", info: description},
      {label: this.translate.instant("DTC.TABLE.EFFECTS") + ":", info: effects},
      {label: this.translate.instant("DTC.TABLE.SUGGESTION") + ":", info: suggestion}
    ];
    this.initialized = true;
  }

}
